import { render, staticRenderFns } from "./gruser-edit.vue?vue&type=template&id=d97b94e4&scoped=true&"
import script from "./gruser-edit.vue?vue&type=script&lang=js&"
export * from "./gruser-edit.vue?vue&type=script&lang=js&"
import style0 from "./gruser-edit.vue?vue&type=style&index=0&id=d97b94e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b94e4",
  null
  
)

export default component.exports